import { createHashRouter, RouterProvider } from 'react-router-dom';
import './App.css';
import './assets/styles/fonts.css';
import { ConfirmCloseDialogProvider } from './contexts/ConfirmCloseDialogContext';
import VerifyOtp from './pages/VerifyOtp';
import { AuthProvider } from './utils/authContext';
import { ROLE_GROUPS } from './config/rolePermissions';
import {
  Router, Route, Routes, Navigate, createTheme, ThemeProvider, IdleHandler,
  ProtectedRoute, Login, ForgotPassword, ResetPassword,
  Dashboard, Users, Clients, AddClient, Frameworks, AddFramework,
  ClientCategory, LookupLayout, ClientRegion,
  FeeStageArea, Tags, Personnel, Projects, AddProjects, General,
  ForecastTracker, InvoiceTracker, Attachments,
  ProjectCategory,
  Proposals, AddProposal,
  ProjectNotes, AFP,
  ProjectSummary,
  ProposalEditFeeStage,
  Profile,
  Outlet,
  CustomConfirmDialog,
    IFSTracker
} from "./utils/globalImports";
import CreatebaseLine from './pages/BaseLine/CreatebaseLine';
import Viewbaseline from './pages/BaseLine/Viewbaseline';
import SummeryBaseLine from './pages/BaseLine/SummeryBaseLine';
import PreviousBaselineList from './pages/BaseLine/PreviousBaselineList';
import ProjectInvoiceList from './pages/Invoicing/ProjectInvoiceList';
import ViewInvoices from './pages/Invoicing/ViewInvoices';
import SelectInvoiceType from './pages/Invoicing/SelectInvoiceType';
import CreateInvoice from './pages/Invoicing/CreateInvoice';
import Settings from './pages/Settings';
import AllInvoices from './pages/Invoicing/AllInvoices';
import AFPTrackerPage from './pages/Project/AFPTracker';
import Unauthorized from './pages/Unauthorized';
import { InvoiceRouteGuard } from './routing/ProtectedRoute';
import NotFound from './pages/NotFound';


const theme = createTheme({
  typography: {
    fontFamily: 'Poppins',
  },
});

// Router config using createHashRouter
const router = createHashRouter([
  {
    path: '/',
    element: <Outlet />,
    children: [
      { index: true, element: <Navigate to="/login" replace /> },
      { path: 'login', element: <Login /> },
      { path: 'forgot-password', element: <ForgotPassword /> },
      { path: 'reset-password', element: <ResetPassword /> },
      { path: 'verify-otp', element: <VerifyOtp /> },
      { path: 'unauthorized', element: <Unauthorized /> },
      { path: '*', element: <NotFound /> },
      {
        element: (
          <>
            <IdleHandler />
            <ProtectedRoute>
              <Outlet />
            </ProtectedRoute>
          </>
        ),
        children: [
          { path: 'dashboard', element: <Dashboard /> },
          { path: 'profile', element: <Profile /> },
          {path:'invoicing',element:<ProtectedRoute allowedRoles={ROLE_GROUPS.INVOICING}><ProjectInvoiceList/></ProtectedRoute>},
          {path:'invoicing/invoices/:projectId',element:<ProtectedRoute allowedRoles={ROLE_GROUPS.INVOICING}><ViewInvoices/></ProtectedRoute>},                  
          {path:'invoicing/:mode/:invoiceId', element:<ProtectedRoute allowedRoles={ROLE_GROUPS.VIEW_INVOICE}><InvoiceRouteGuard/></ProtectedRoute>},
          {path:'invoiceList',element:<ProtectedRoute allowedRoles={ROLE_GROUPS.INVOICE_LIST}><AllInvoices /></ProtectedRoute>},
          {path:'invoicing/invoice-type',element:<ProtectedRoute allowedRoles={ROLE_GROUPS.INVOICING}><SelectInvoiceType/></ProtectedRoute>},
          {path:'invoicing/create-invoice',element:<ProtectedRoute allowedRoles={ROLE_GROUPS.INVOICING}><CreateInvoice/></ProtectedRoute>},
          {path:'invoiceList/viewinvoices',element:<ProtectedRoute allowedRoles={ROLE_GROUPS.VIEW_INVOICE}><CreateInvoice/></ProtectedRoute>},
          { path: 'ifs-tracker', element: <IFSTracker /> },
          { path: 'create-baseline', element: <ProtectedRoute allowedRoles={ROLE_GROUPS.INVOICING}><CreatebaseLine /></ProtectedRoute> },
          { path: 'view-baseline', element: <ProtectedRoute allowedRoles={ROLE_GROUPS.BASELINE_VIEW}><Viewbaseline /></ProtectedRoute> },
          {path:'settings',element:<ProtectedRoute allowedRoles={ROLE_GROUPS.BASELINE}><Settings/></ProtectedRoute>},
          // { path: 'summery-baseline', element: <ProtectedRoute allowedRoles={ROLE_GROUPS.BASELINE}><SummeryBaseLine /></ProtectedRoute> },
          { path: 'user/users', element: <ConfirmCloseDialogProvider CustomDialogComponent={CustomConfirmDialog}><Users /></ConfirmCloseDialogProvider> },
          { path: 'client/clients', element: <Clients /> },
          { path: 'client/add-client', element: <ConfirmCloseDialogProvider CustomDialogComponent={CustomConfirmDialog}><AddClient /></ConfirmCloseDialogProvider> },
          { path: 'client/add-client/:clientId', element: <ConfirmCloseDialogProvider CustomDialogComponent={CustomConfirmDialog}><AddClient /></ConfirmCloseDialogProvider> },

          { path: 'framework/frameworks', element: <Frameworks /> },
          { path: 'framework/add-framework', element: <ConfirmCloseDialogProvider CustomDialogComponent={CustomConfirmDialog}><AddFramework /></ConfirmCloseDialogProvider> },
          { path: 'framework/add-framework/:frameworkId', element: <ConfirmCloseDialogProvider CustomDialogComponent={CustomConfirmDialog}><AddFramework /> </ConfirmCloseDialogProvider> },

          { path: 'project/projects', element: <Projects /> },
          { path: 'Baseline/PreviousBaselineList', element: <ProtectedRoute allowedRoles={ROLE_GROUPS.BASELINE}><PreviousBaselineList /></ProtectedRoute> },

          {
            path: 'project/add-projects',
            element: <AddProjects />,
            children: [
              { index: true, element: <Navigate to="general" replace /> },
              { path: 'general', element: <General /> },
            ],
          },
          {
            path: 'project/edit-projects/:projectId',
            element: <AddProjects />,
            children: [
              { index: true, element: <Navigate to="general" replace /> },
              { path: 'general', element: <General /> },
              { path: 'notes', element: <ProjectNotes /> },
              { path: 'attachments', element: <Attachments /> },
              { path: 'afp', element: <AFP /> },
              { path: 'summary', element: <ProjectSummary /> },
                { path: 'forecast-tracker', element: <ForecastTracker /> },
                { path: 'afp-tracker', element: <AFPTrackerPage /> },
              { path: 'invoice-tracker', element: <InvoiceTracker /> },
              { path: 'category/categories', element: <ProjectCategory /> },
            ],
          },
          {
            path: 'proposal/Proposals/:projectId/:projectName',
            element: <Proposals />,
          },
          {
            path: 'proposal/add-proposal/:projectId/:projectName',
            element: <AddProposal />,
          },
          {
            path: 'proposal/add-proposal/:projectId/:proposalId/:projectName',
            element: <AddProposal />,
          },
          {
            path: 'proposal/feestage/edit-feestage/:feeStageId/:readonly',
            element: <ProposalEditFeeStage />,
          },

          {
            path: 'lookup',
            element: <LookupLayout />,
            children: [
              { path: 'client-category', element: <ConfirmCloseDialogProvider CustomDialogComponent={CustomConfirmDialog}><ClientCategory /></ConfirmCloseDialogProvider> },
              { path: 'client-region', element: <ConfirmCloseDialogProvider CustomDialogComponent={CustomConfirmDialog}><ClientRegion /></ConfirmCloseDialogProvider> },
              { path: 'fee-stage-area', element: <ConfirmCloseDialogProvider CustomDialogComponent={CustomConfirmDialog}><FeeStageArea /></ConfirmCloseDialogProvider> },
              { path: 'tags', element: <ConfirmCloseDialogProvider CustomDialogComponent={CustomConfirmDialog}><Tags /></ConfirmCloseDialogProvider> },
              { path: 'personnel', element: <ConfirmCloseDialogProvider CustomDialogComponent={CustomConfirmDialog}><Personnel /></ConfirmCloseDialogProvider> },
            ],
          },

          { path: 'lookup/client-category', element: <ClientCategory /> },
          { path: '*', element: <NotFound /> },
        ],
      },
    ],
  },
]);

// Main App component providing the router
function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
